import React from 'react';

/**
 * SectionHeading — the editorial section opener. A mono eyebrow with an
 * index number, an accent rule, then the big display title.
 */
export function SectionHeading({ eyebrow, index, title, align = 'left' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)', alignItems: align === 'center' ? 'center' : 'flex-start', textAlign: align }}>
      {(eyebrow || index) && (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem' }}>
          {index && (
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-2xs)', color: 'var(--text-muted)', letterSpacing: 'var(--tracking-widest)' }}>
              {index}
            </span>
          )}
          <span style={{ width: '2rem', height: '1px', background: 'var(--border-accent)' }} />
          <span className="t-eyebrow">{eyebrow}</span>
        </div>
      )}
      <h2 style={{ fontSize: 'var(--text-display)', fontWeight: 'var(--weight-bold)', letterSpacing: 'var(--tracking-tight)', lineHeight: 'var(--leading-tight)', margin: 0 }}>
        {title}
      </h2>
    </div>
  );
}

export default SectionHeading;
